/**
 * @author Fernando FH
 * @company Erillam Healthcare
 * @version 1.0
 */

 import ServicePath from "@/core/ServicePath"
 import { MainRequest } from "@/core/request";

 export default class LocationRequest extends MainRequest{


   static listAll(object) {
      return this.postSEC(ServicePath.LOCATION_ALL, object);
   }

   static addLocation(object) {
      return this.postSEC(ServicePath.LOCATION_ADD, object);
   }

   static updateLocation(object) {
      return this.postSEC(ServicePath.LOCATION_UPDATE, object);
   }

   static getLocation(object) {
      return this.postSEC(ServicePath.LOCATION_BY_ID, object);
   }

   static getLocationByClues(object) {
      return this.postSEC(ServicePath.LOCATION_BY_CLUES, object);
   }
     

     static add(object) {
        return this.postSEC(ServicePath.CONFIGURATION_ADD_LOCATION, object);
     }

    //  static update(object) {
    //     return this.postSEC(ServicePath.MODULE_UPDATE, object);
    //  }

     static get(object) {
        return this.postSEC(ServicePath.CONFIGURATION_GET_LOCATION, object);
     }

     static getClues(object) {
      return this.postSEC(ServicePath.CONFIGURATION_GET_CLUES, object);
   }

     static saveClues(object) {
      return this.postSEC(ServicePath.CONFIGURATION_SAVE_CLUES, object);
   }

    //  static delete(object) {
    //     return this.postSEC(ServicePath.MODULE_DELETE, object);
    //  }

 }